import React from 'react';
import VenereSimpleLayout from '../../shared/pages/VenereSimpleLayout';

export const VenereAccountPage: React.FC = () => {
  return (
    <VenereSimpleLayout
      showBackButton={true}
      backButtonText="Back"
    >
      <div className="w-full mx-auto py-8">
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 md:p-8">
          <h1 className="text-2xl font-bold text-gray-900 mb-6">Account</h1>

          <div className="space-y-6">
            {/* Profile Section */}
            <div className="border-b border-gray-200 pb-6">
              <h2 className="text-lg font-semibold text-gray-900 mb-4">Informazioni personali</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Nome
                  </label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0B4651] focus:border-transparent"
                    placeholder="Inserisci il tuo nome"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Cognome
                  </label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0B4651] focus:border-transparent"
                    placeholder="Inserisci il tuo cognome"
                  />
                </div>
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Email
                  </label>
                  <input
                    type="email"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0B4651] focus:border-transparent"
                    placeholder="Inserisci la tua email"
                  />
                </div>
              </div>
            </div>

            {/* Security Section */}
            <div>
              <h2 className="text-lg font-semibold text-gray-900 mb-4">Sicurezza</h2>
              <div className="space-y-3">
                <button className="w-full text-left px-4 py-3 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
                  <div className="flex items-center justify-between">
                    <div>
                      <h3 className="text-sm font-medium text-gray-900">Cambia password</h3>
                      <p className="text-sm text-gray-500">Aggiorna la tua password</p>
                    </div>
                    <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                </button>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex justify-end space-x-3 mt-8 pt-6 border-t border-gray-200">
            <button className="px-4 py-2 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors">
              Annulla
            </button>
            <button className="px-4 py-2 bg-[#0B4651] text-white rounded-lg hover:bg-[#0a3d47] transition-colors">
              Salva modifiche
            </button>
          </div>
        </div>
      </div>
    </VenereSimpleLayout>
  );
};

export default VenereAccountPage; 